var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievedNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4 -7 65 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9586 19.0161L29.1498 1.58567C28.4599 1.10097 27.5401 1.10097 26.8502 1.58567L2.04143 19.0161C1.31161 19.5289 1.00955 20.4629 1.30092 21.3059L10.7533 48.6534C11.0318 49.4593 11.7908 50 12.6435 50H43.3565C44.2092 50 44.9682 49.4593 45.2467 48.6534L54.6991 21.3059C54.9905 20.4629 54.6884 19.5289 53.9586 19.0161Z",
    stroke: "#BBBBBB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievedNegative);
export default __webpack_public_path__ + "static/media/achieved-negative.fc2a08aa600eaa6b334e95a6d709c11d.svg";
export { ForwardRef as ReactComponent };